import {
  Button,
  Form,
  Input,
  List,
  Popconfirm,
  Space,
  Typography,
  message,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import Admin from "../../../service/Admin";
import Public from "../../../service/Public";

const FAQs = () => {
  const [data, setData] = useState([]);
  const [form] = Form.useForm();

  const loadData = useCallback(async () => {
    const data = await Public.getFAQs();

    if (data.data.FAQs)
      setData(
        Object.keys(data.data.FAQs).map((d) => ({
          key: d,
          ...data.data.FAQs[d],
        }))
      );
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const onFinish = useCallback(
    async (values) => {
      const newPricingElement = {
        question: values.question,
        answer: values.answer,
        key: uuid(),
      };

      setData((data) => {
        const myList = [...data, newPricingElement];
        Admin.setFAQs({ FAQs: myList });

        return myList;
      });

      form.resetFields();
    },
    [form]
  );

  const renderItem = (item) => (
    <List.Item
      style={{
        flexDirection: "column",
        textAlign: "left",
        alignItems: "self-start",
        width: "100%",
      }}
    >
      <div style={{ width: "100%" }}>
        <strong>Question</strong>{" "}
        <Typography.Text
          style={{ display: "block", margin: "10px 0", width: "100%" }}
          editable={{
            value: item.question,
            onChange: (e) => {
              setData((list) => {
                const myList = [...list];
                const myItem = { ...item, question: e };
                const itemFromListIdx = myList.findIndex(
                  (l) => l.key === myItem.key
                );
                myList[itemFromListIdx] = myItem;
                Admin.setFAQs({ FAQs: myList });
                return myList;
              });
            },
          }}
        >
          {item.question}
        </Typography.Text>
      </div>
      <div style={{ width: "100%" }}>
        <strong>Answer</strong>{" "}
        <Typography.Text
          style={{ display: "block", margin: "10px 0", width: "100%" }}
          editable={{
            value: item.answer,
            onChange: (e) => {
              setData((list) => {
                const myList = [...list];
                const myItem = { ...item, answer: e };
                const itemFromListIdx = myList.findIndex(
                  (l) => l.key === myItem.key
                );
                myList[itemFromListIdx] = myItem;
                Admin.setFAQs({ FAQs: myList });
                return myList;
              });
            },
          }}
        >
          {item.answer}
        </Typography.Text>
      </div>
      <Space>
        <Popconfirm
          title="Sure?"
          onConfirm={() => {
            setData((list) => {
              const myList = list.filter((l) => l.key !== item.key);
              Admin.setFAQs({ FAQs: myList });
              return myList;
            });
          }}
        >
          <Button danger>Delete</Button>
        </Popconfirm>
      </Space>
    </List.Item>
  );

  return (
    <div>
      <h4>FAQ</h4>
      <List dataSource={data} renderItem={renderItem} />

      <div className="p-3 backdrop-blur-xl rounded-lg">
        <h5>Add New Question</h5>
        <br />
        <Form form={form} onFinish={onFinish} size="small">
          <Form.Item
            label="Question"
            name="question"
            rules={[{ required: true, message: "Please enter a question" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Answer"
            name="answer"
            rules={[{ required: true, message: "Please enter a answer" }]}
          >
            <Input />
          </Form.Item>
          <Space>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Space>
        </Form>
      </div>
    </div>
  );
};

export default FAQs;
